import React, { useState } from 'react'
import { classNames } from '../_utils'

import { at } from 'lodash'
import { useField } from 'formik'
import Theme from '../Theme'


const TextFieldIcon = ( { required = false, noPadding = false, disabled =  false, question = "", name, iconComponent, type =  "text", label, handleChange, handleBlur, value } ) => {
  const [ passwordVisibility, setPasswordVisible ] = useState( false )
  const [ field, meta ] = useField( name || "" )

  const _renderText = () => {
    const [ touched, error ] = at( meta, 'touched', 'error' ) 
    if( touched && error )
      return error
    
  }

  return (
    <div className={ classNames( noPadding ? "flex flex-col items-start" : "flex flex-col items-start my-2" ) }>
      <p className="text-gray-700 text-xs">
       {question}{ required && ( <span className="text-red-500 font-bold">*</span>) }
      </p>
      <div className={ classNames( ( meta.touched && meta.error ) ? "inline-flex w-full rounded border border-red-500 relative" : "inline-flex w-full rounded-sm relative" ) }>
        {/* <div className="w-1/6 flex items-center justify-center bg-gray-50">
          <span>{iconComponent}</span>
        </div> */}
        <input 
          name={name}
          disabled={disabled}
          id={name}
          type={type === "password" ? ( passwordVisibility ? "text" : "password" ) : type } 
          placeholder={label}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
          required={required}
          autoComplete="off"
          className={ classNames( ( meta.touched && meta.error ) ? "w-full px-3 py-1 focus:outline-none focus:text-gray-600 placeholder-red-500 text-base" : "w-full px-3 py-1 focus:outline-none focus:text-gray-700 placeholder-gray-400 text-base" ) } 
        />
        {type === "password" && 
        <div onClick={() => setPasswordVisible( !passwordVisibility )} className="cursor-pointer w-12 h-8 absolute top-0 right-0 flex items-center justify-center">
          {Theme.EyeIcon}
        </div>}
    </div>
      
    {(meta.touched && meta.error) ? (
      <p className="text-red-500 py-1 text-sm">
        {_renderText()}
      </p>
    ) : (
      <p className="text-gray-700 py-1 text-sm">
        {/* {question}{ required && ( <span className="text-red-500">*</span>) } */}
      </p>
    ) }
    
  </div>
  )
}

export default TextFieldIcon
